<template>
  <div class="relative w-full">
    <div
      class="flex flex-col flex-wrap min-w-0 break-words shadow-lg rounded-md bg-white"
    >
      <BannerNotification />
      <div class="mb-0 pb-3 px-4 border-0">
        <div class="flex flex-wrap justify-end items-center">
          <div class="relative inline-block pt-3" id="section-menu-container">
            <button
              @click="() => (opened = true)"
              type="button"
              class="inline-flex justify-between bg-white w-40 pl-4 pr-3 py-2 rounded-md border border-gray-300 shadow-sm text-sm font-bold text-gray-700 hover:bg-gray-50 focus:outline-none"
              id="options-menu"
              aria-expanded="true"
              aria-haspopup="true"
            >
              <span v-html="selectedSection.label"></span>
              <!-- Heroicon name: solid/chevron-down -->
              <svg
                class="h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
            <div
              v-click-outside="handleClose"
              v-if="opened"
              class="origin-top-right absolute right-0 mt-2 w-40 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="options-menu"
            >
              <div class="py-1" role="none">
                <div v-for="(section, index) in sections" :key="index">
                  <a
                    href="#"
                    class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                    role="menuitem"
                    @click="handleClick(section.value)"
                    ><span v-html="section.label"></span
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="py-1 px-4"><hr /></div>
      <div class="block w-full">
        <GalleryInfoSection v-if="tab === 0" />
        <ImageInfoSection v-if="tab === 1" />
      </div>
    </div>
  </div>
</template>

<script>
import BannerNotification from "@/components/Shared/Notification/BannerNotification";
import GalleryInfoSection from "@/components/ComponentModule/ShopTheLook/GalleryInfoSection";
import ImageInfoSection from "@/components/ComponentModule/ShopTheLook/ImageInfoSection";

export default {
  name: "ShopTheLook",
  components: {
    BannerNotification,
    GalleryInfoSection,
    ImageInfoSection
  },
  data() {
    return {
      tab: 0,
      opened: false,
      sections: [
        {
          label: "<i class='fas fa-images mr-1'></i>Gallery",
          value: 0
        },
        { label: "<i class='fas fa-image mr-1'></i>Image", value: 1 }
      ]
    };
  },
  computed: {
    selectedSection() {
      return this.sections.find((obj) => {
        return obj.value === this.tab;
      });
    }
  },
  directives: {
    "click-outside": {
      mounted(el, { value: closeFunction }) {
        window.addEventListener("click", closeFunction);
      },
      unmounted(el, { value: closeFunction }) {
        window.removeEventListener("click", closeFunction);
      }
    }
  },
  methods: {
    handleClose() {
      if (this.opened) {
        if (
          !document
            .getElementById("section-menu-container")
            .contains(window.event.target)
        ) {
          this.opened = false;
        }
      } else {
        this.opened = true;
      }
    },
    handleClick(tab) {
      this.tab = tab;
    }
  }
};
</script>
